import { graphql } from "react-relay";

// components
import "@components/autopilot-feed-status/AutopilotFeedStatus.gql";
import "@components/tailored-defrag-summary-card/TailoredDefragSummaryCard.gql";
import "@components/autopilot-suggestions-card/AutopilotSuggestionsCard.gql";

export const query = graphql`
  query ChromeAutopilotFeedStatusDefragCardRendererQuery($orgRelayId: ID!, $timeZone: String!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...AutopilotFeedStatus_org @arguments(timeZone: $timeZone)
        ...TailoredDefragSummaryCard_org
        ...AutopilotSuggestionsCard_org
        experiments
        tailoredDefragCardSummary {
          __typename
          ... on TailoredDefragCardSummary {
            defragTime
            yourEventMoves {
              event {
                title
              }
            }
            knobs {
              inviteOrganizerKnobs {
                knobUrn {
                  type
                  value
                }
              }
              autopilotMeetingKnobs {
                knobUrn {
                  type
                  value
                }
              }
              lessenAutopilotConstraintKnobs {
                knobUrn {
                  type
                  value
                }
              }
            }
            referencedEvents {
              eventKey {
                externalEventId
              }
            }
          }
        }
      }
    }
    viewer: viewer {
      user {
        ...AutopilotFeedStatus_user
      }
    }
  }
`;
